import { render, staticRenderFns } from "./VehicleMonthlyCO2Chart.vue?vue&type=template&id=2dc38757&scoped=true"
import script from "./VehicleMonthlyCO2Chart.vue?vue&type=script&lang=ts"
export * from "./VehicleMonthlyCO2Chart.vue?vue&type=script&lang=ts"
import style0 from "./VehicleMonthlyCO2Chart.vue?vue&type=style&index=0&id=2dc38757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc38757",
  null
  
)

export default component.exports